const modules = import.meta.glob<Record<string, unknown>>('./locales/*/*.json', {
  eager: true,
  import: 'default',
});

const AREA_FILE = /^\.\/locales\/([a-z]{2})\/([A-Za-z]+)\.json$/;

/** `locales/<lang>/<area>.json` nested under `<area>`, so its keys read `<area>.<name>`. */
export function areaResources(lang: string): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [path, contents] of Object.entries(modules)) {
    const match = AREA_FILE.exec(path);
    if (match && match[1] === lang) {
      out[match[2]] = contents;
    }
  }
  return out;
}
